module.exports = __webpack_public_path__ + "static/Lucas_Rubrik_Sve-bc72480a23c6a046252d1604b214dc54.svg";